'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _language = require('./language.png');

var _language2 = _interopRequireDefault(_language);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _FirebaseAuth = require('helpers/FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _setup = require('redux/modules/setup');

var _Search = require('../Search/Search.js');

var _Search2 = _interopRequireDefault(_Search);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _lodash = require('lodash');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loginError: state.auth.loginError,
    openLoginForm: state.auth.openLoginForm
  };
}, (0, _extends3.default)({}, authActions, { setPathName: _setup.setPathName })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Header, _Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      unfixed: true,
      more100vh: false,
      errorMsg: '',
      // inputs: {
      //   email: '',
      //   password: '',
      //   save: false
      // },
      currentLocation: {},
      // emailValidate: true,
      // passwordValidate: true,
      showModalInfo: false,
      target: function target() {
        return _reactDom2.default.findDOMNode(_this.refs.login);
      }
    }, _this.onScroll = function () {
      if (process.env.NODE_ENV !== 'development') {
        var flag = false;
        if ((window.scrollY < 18 || document.body.scrollTop !== 0 && document.body.scrollTop < 18) && !_this.state.unfixed) {
          flag = true;
          _this.setState({ unfixed: true });
        }
        if ((window.scrollY > 18 || document.body.scrollTop !== 0 && document.body.scrollTop > 18) && _this.state.unfixed) {
          flag = true;
          _this.setState({ unfixed: false });
        }
        var docHeight = document.getElementById('welcomePage');
        if (docHeight) {
          var documentInner = document.body.scrollTop > document.getElementById('welcomePage').scrollHeight - 125 || window.scrollY > document.getElementById('welcomePage').scrollHeight - 125;
          if (documentInner && !_this.state.more100vh) {
            flag = true;
            _this.setState({ more100vh: true });
          }
          if (!documentInner && _this.state.more100vh) {
            flag = true;
            _this.setState({ more100vh: false });
          }
        }
        if (_this.props.openLoginForm && flag) {
          _this.props.closeLoginFormAction();
        }
      } else {
        var _flag = false;
        if (window.scrollY < 18 && !_this.state.unfixed) {
          _flag = true;
          _this.setState({ unfixed: true });
        }
        if (window.scrollY > 18 && _this.state.unfixed) {
          _flag = true;
          _this.setState({ unfixed: false });
        }
        var windowInner = window.scrollY > window.innerHeight - 125;
        if (windowInner && !_this.state.more100vh) {
          _flag = true;
          _this.setState({ more100vh: true });
        }
        if (!windowInner && _this.state.more100vh) {
          _flag = true;
          _this.setState({ more100vh: false });
        }
        if (_this.props.openLoginForm && _flag) {
          _this.props.closeLoginFormAction();
        }
      }
    }, _this.closeLoginForm = function () {
      _this.props.closeLoginFormAction();
    }, _this.handleClick = function () {
      if (_this.props.openLoginForm) {
        _this.props.closeLoginFormAction();
      } else {
        _this.props.openLoginFormAction();
      }
    }, _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _this.handleOpenModalInfo = function () {
      _this.setState({
        showModalInfo: true,
        errorMsg: ''
      });
    }, _this.handleCloseModalInfo = function () {
      _this.setState({
        showModalInfo: false
      });
    }, _this.saveLocation = function () {
      _this.setState({
        currentLocation: _this.props.location
      });
    }, _this.loginFacebook = function () {
      window.FB.login();
    }, _this.setPath = function () {
      // event.preventDefault();
      _this.props.setPathName(_this.props.location.pathname);
    }, _this.responseGoogleSuccess = function (response) {
      _this.props.loginGoogle(response.accessToken);
    }, _this.responseGoogleFailure = function (response) {
      if (response.error === 'access_denied') {
        _this.setState({ errorMsg: 'Vui lòng cấp quyền cho app' });
        _this.handleOpenModalInfo();
      } else if (response.error === 'immediate_failed') {
        _this.setState({ errorMsg: 'Đã xảy ra lỗi. Vui lòng thử lại' });
        _this.handleOpenModalInfo();
      }
    }, _this.responsePhone = function (response) {
      _this.props.loginPhone(response);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false);
      document.body.addEventListener('scroll', this.onScroll, false);
      this.saveLocation();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (!(0, _lodash.isEqual)(this.props.location, this.state.currentLocation)) {
        this.saveLocation();
        if (this.props.openLoginForm) {
          this.props.closeLoginFormAction();
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false);
      document.body.addEventListener('scroll', this.onScroll, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loginError !== null && !(0, _lodash.isEqual)(this.props.loginError, nextProps.loginError)) {
        if (nextProps.loginError.msg && nextProps.loginError.code === 'INACTIVE') {
          this.handleOpenModalInfo();
        } else {
          console.log('Mã lỗi: ', nextProps.loginError.code);
        }
      }
    }
    // onChangeEmail = (event) => {
    //   let emailValidate = false;
    //   if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value) || event.target.value === '') {
    //     emailValidate = true;
    //   }
    //   const inputs = this.state.inputs;
    //   inputs.email = event.target.value;
    //   this.setState({
    //     inputs: inputs,
    //     emailValidate: emailValidate
    //   });
    // }
    // onChangePassword = (event) => {
    //   let passwordValidate = false;
    //   if (event.target.value.length >= 8 || event.target.value === '') {
    //     passwordValidate = true;
    //   }
    //   const inputs = this.state.inputs;
    //   inputs.password = event.target.value;
    //   this.setState({
    //     inputs: inputs,
    //     passwordValidate: passwordValidate
    //   });
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          user = _props.user,
          loginError = _props.loginError,
          openLoginForm = _props.openLoginForm;
      var _state = this.state,
          unfixed = _state.unfixed,
          more100vh = _state.more100vh,
          target = _state.target,
          errorMsg = _state.errorMsg;

      var styles = require('./Header.scss');
      var home = this.props.location && this.props.location.pathname !== '/' ? false : true;
      // const = this.showModalInfo && loginError.msg.indexOf("")
      return _react2.default.createElement(
        'div',
        {
          className: styles.header + ' ' + (home && unfixed ? styles.homePage : styles.fixed)
        },
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 3 },
                _react2.default.createElement(
                  'div',
                  { className: styles.logoBox },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' },
                    _react2.default.createElement('div', { className: styles.brand })
                  )
                )
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 6, className: styles.boxSearch },
                _react2.default.createElement(_Search2.default, { position: 'header', location: this.props.location })
              ),
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 3, className: styles.loginGroup },
                !user && _react2.default.createElement(
                  _reactBootstrap.ButtonToolbar,
                  { className: styles.loginControl },
                  _react2.default.createElement(
                    'div',
                    {
                      ref: 'login',
                      className: styles.buttonLogin + ' ' + (openLoginForm ? styles.popActive : ''),
                      onClick: this.handleClick
                    },
                    _react2.default.createElement('i', {
                      className: 'fa fa-user ' + styles.icon,
                      'aria-hidden': 'true'
                    }),
                    '\u0110\u0103ng nh\u1EADp'
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Overlay,
                    {
                      show: openLoginForm,
                      target: target,
                      placement: 'bottom',
                      container: this,
                      containerPadding: 20
                    },
                    _react2.default.createElement(
                      _reactBootstrap.Popover,
                      {
                        id: 'popover-user',
                        className: styles.popoverLogin
                      },
                      _react2.default.createElement(
                        'div',
                        { className: styles.contentPopover },
                        _react2.default.createElement(
                          'div',
                          { className: styles.social },
                          _react2.default.createElement(
                            'div',
                            {
                              className: styles.facebook,
                              onClick: function onClick() {
                                return _this2.loginFacebook();
                              }
                            },
                            _react2.default.createElement('i', {
                              className: 'fa fa-facebook ' + styles.icon,
                              'aria-hidden': 'true'
                            }),
                            _react2.default.createElement(
                              'span',
                              { className: styles.socialLabel },
                              'Facebook'
                            )
                          ),
                          _react2.default.createElement(_reactGoogleLogin2.default, {
                            autoLoad: false,
                            clientId: _config2.default.googleId,
                            onSuccess: this.responseGoogleSuccess.bind(this),
                            onFailure: this.responseGoogleFailure.bind(this),
                            render: function render(renderProps) {
                              return _react2.default.createElement(
                                'div',
                                {
                                  className: styles.google,
                                  onClick: renderProps.onClick
                                },
                                _react2.default.createElement('i', {
                                  className: 'fa fa-google ' + styles.icon
                                }),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  'Google'
                                )
                              );
                            }
                          })
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            _FirebaseAuth2.default,
                            {
                              desktopMode: true,
                              onResponse: this.responsePhone
                            },
                            function (p) {
                              return _react2.default.createElement(
                                'button',
                                (0, _extends3.default)({}, p, { className: styles.phone }),
                                _react2.default.createElement('i', {
                                  className: 'fa fa-phone ' + styles.icon,
                                  'aria-hidden': 'true'
                                }),
                                'Login with Phone Number'
                              );
                            }
                          )
                        ),
                        _react2.default.createElement(
                          _FirebaseAuth2.default,
                          {
                            desktopMode: true,
                            onResponse: this.responsePhone
                          },
                          function (p) {
                            return _react2.default.createElement(
                              'div',
                              (0, _extends3.default)({}, p, { className: styles.register }),
                              '\u0110\u0103ng K\xFD Ngay'
                            );
                          }
                        )
                      )
                    )
                  )
                ),
                user && _react2.default.createElement(
                  _reactBootstrap.NavDropdown,
                  {
                    eventKey: 3,
                    title: user.profile.name,
                    className: styles.dropdown,
                    id: 'basic-nav-dropdown'
                  },
                  _react2.default.createElement(
                    _reactRouterBootstrap.LinkContainer,
                    { to: '/tai-khoan' },
                    _react2.default.createElement(
                      _reactBootstrap.NavItem,
                      { eventKey: 3.1, className: 'logout-link' },
                      'Trang c\xE1 nh\xE2n'
                    )
                  ),
                  _react2.default.createElement(
                    _reactRouterBootstrap.LinkContainer,
                    { to: '/dang-xuat' },
                    _react2.default.createElement(
                      _reactBootstrap.NavItem,
                      {
                        eventKey: 3.2,
                        className: 'logout-link',
                        onClick: this.handleLogout
                      },
                      '\u0110\u0103ng xu\u1EA5t'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.dropdownLanguage + ' display-none' },
                  _react2.default.createElement('img', { src: _language2.default, alt: 'en' })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: styles.category + ' ' + (home && !more100vh ? '' : styles.activeCategory)
          },
          _react2.default.createElement(
            _reactBootstrap.Grid,
            null,
            _react2.default.createElement(
              _reactBootstrap.Row,
              null,
              _react2.default.createElement(
                _reactBootstrap.Col,
                { md: 12 },
                _react2.default.createElement(
                  'div',
                  { className: styles.categoryContainer },
                  _react2.default.createElement(
                    'div',
                    { className: styles.itemCat },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/salon-mi-va-mong' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupItem },
                        _react2.default.createElement('div', {
                          className: styles.icon + ' ' + styles.itemSalonMiMong
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: styles.title },
                          'Salon Mi v\xE0 M\xF3ng'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.itemCat },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/spa-cham-da' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupItem },
                        _react2.default.createElement('div', {
                          className: styles.icon + ' ' + styles.itemSpaChamDa
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: styles.title },
                          'Spa Ch\u0103m Da'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.itemCat },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/massage-va-goi-dau' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupItem },
                        _react2.default.createElement('div', {
                          className: styles.icon + ' ' + styles.itemMassageGoiDau
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: styles.title },
                          'Massage G\u1ED9i \u0110\u1EA7u'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.itemCat },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/tham-my-va-nha-khoa' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupItem },
                        _react2.default.createElement('div', {
                          className: styles.icon + ' ' + styles.itemThamMyNhaKhoa
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: styles.title },
                          'Th\u1EA9m M\u1EF9 Nha Khoa'
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.itemCat },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/salon-toc-va-make-up' },
                      _react2.default.createElement(
                        'div',
                        { className: styles.groupItem },
                        _react2.default.createElement('div', {
                          className: styles.icon + ' ' + styles.itemSalonTocMakeUp
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: styles.title },
                          'Salon T\xF3c Make-up'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: this.state.showModalInfo,
            onHide: this.handleCloseModalInfo,
            className: 'modal-alert-login'
          },
          _react2.default.createElement(
            _reactBootstrap.Modal.Header,
            { closeButton: true },
            _react2.default.createElement(
              _reactBootstrap.Modal.Title,
              null,
              'Th\xF4ng b\xE1o'
            )
          ),
          _react2.default.createElement(
            _reactBootstrap.Modal.Body,
            null,
            errorMsg ? errorMsg : '',
            loginError ? loginError.msg : ''
          )
        )
      );
    }
  }]);
  return Header;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  loginError: _react.PropTypes.object,
  login: _react.PropTypes.func,
  logout: _react.PropTypes.func.isRequired,
  setPathName: _react.PropTypes.func.isRequired,
  location: _react.PropTypes.object,
  // home: PropTypes.bool,
  openLoginForm: _react.PropTypes.bool,
  openLoginFormAction: _react.PropTypes.func,
  closeLoginFormAction: _react.PropTypes.func,
  loginGoogle: _react.PropTypes.func,
  loginPhone: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Partials/Header.js
// module id = 1647
// module chunks = 0